import sofiaSansSemiCondensedTtfHref from "../../assets/fonts/SofiaSansSemiCondensed/SofiaSansSemiCondensed-VariableFont_wght.ttf";
import sofiaSansSemiCondensedItalicTtfHref from "../../assets/fonts/SofiaSansSemiCondensed/SofiaSansSemiCondensed-Italic-VariableFont_wght.ttf";
import { preloadFont } from "troika-three-text";
import {
    STANDARD_FONTS,
    fontBarlowSemiCondensed,
    fontBarlowSemiCondensedBold,
    fontBarlowSemiCondensedBlack,
} from "../../assets/fonts";

export const Font = {
    SOFIA_SANS_SEMI_CONDENSED: "SofiaSansSemiCondensed",
    SOFIA_SANS_SEMI_CONDENSED_ITALIC: "SofiaSansSemiCondensedItalic",
} as const;
export type Font = (typeof Font)[keyof typeof Font];

// Familie (= `content.family` aus dem Editor) → Font-URL für Troika.
// Jans Fund #6: Diese Map enthielt nur die zwei Sofia-Fonts — JEDE andere
// Wahl im Schrift-Dropdown fiel still auf DEFAULT_FONT zurück, der
// Schriftwechsel im Text-Layer war damit wirkungslos. Jetzt: alle
// Standard-Fonts des Pro-Editor-Pickers (STANDARD_FONTS-Barrel) + die
// Gravur-Legacy-Aliasse (nicht lizenziert → Barlow Semi Condensed in den
// passenden Gewichten, exakt wie in Jans Original-FONTS-Map — bestehende
// Stories mit Gravur-Familien rendern damit weiter korrekt).
export const FONTS: Record<string, string> = {
    [Font.SOFIA_SANS_SEMI_CONDENSED]: sofiaSansSemiCondensedTtfHref,
    [Font.SOFIA_SANS_SEMI_CONDENSED_ITALIC]: sofiaSansSemiCondensedItalicTtfHref,
    ...STANDARD_FONTS,
    Gravur: fontBarlowSemiCondensed,
    GravurBold: fontBarlowSemiCondensedBold,
    GravurBlack: fontBarlowSemiCondensedBlack,
};

export const DEFAULT_FONT = FONTS.SofiaSansSemiCondensed;

// Eagerly preload font SDF atlases at module-import time.
// This runs when the Editor page's JS chunk loads — well before the
// renderer initializes — giving troika's web worker enough time to
// build the atlas before the first updateText() call.
//
// Bewusst NICHT alle FONTS: seit der Map-Erweiterung wären das 17 Atlanten
// bei jedem Reader-Load. Der Preload bleibt auf dem bisherigen Satz
// (Sofia ×2 + Italianno/NotoSans/NotoSerif); jede weitere Familie baut
// Troika beim ersten `text.font`-Zuweisen nach — der sync-Callback in
// updateText rendert dann einmal nach, sobald der Atlas steht.
//
// SSR-Guard (Phase 12 Step 2): `preloadFont` kickt troika's Web-Worker-
// Setup an, der intern `self` liest — das crasht in vike's SSR-Umgebung
// (Node, kein `self`). Unter SSR überspringen wir den Preload komplett
// und verlassen uns darauf, dass der echte Mount (Browser-only, via
// ClientOnly-Wrapper in public's ViewerChrome) den Atlas just-in-time
// aufbaut. Editor-Chunks laufen weiter im Browser, da ändert sich nichts.
const PRELOAD_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZäöüÄÖÜß0123456789.,;:!?-–—()[]{}"\' ';
if (typeof window !== "undefined") {
    const preloadSet = [
        sofiaSansSemiCondensedTtfHref,
        sofiaSansSemiCondensedItalicTtfHref,
        STANDARD_FONTS.Italianno,
        STANDARD_FONTS.NotoSans,
        STANDARD_FONTS.NotoSerif,
    ];
    for (const font of preloadSet) {
        preloadFont({ font, characters: PRELOAD_CHARS }, () => { /* atlas ready */ });
    }
}
